export const buildBaseUri = () => "/";
export const build404Uri = () => "/404";
export const buildComingSoonUri = () => "/coming-soon";

export const buildLoginUri = () => "/login";

export const buildForgotPasswordUri = (id = ":id") => `/forgot-password/${id}`;

export const buildLeadFormUri = (id = ":id") => `/external-form/${id}`;

export const buildProfileUri = () => "/profile";

export const buildResetPasswordUri = () => "/reset-password";

export const buildGlobalSettingUri = () => "/global-settings";
export const buildFinportGoalsUri = () => "/finport-goals";
export const buildSettingUri = () => "/settings";
export const buildLeadDashboardUri = () => "/lead-dashboard";

export const buildEmergencyContactUri = () => "/emergency-contact";
export const buildManageEmergencyContactTemplateUri = () =>
  "/manage-emergency-contact-template";

export const buildDashboardUri = () => "/dashboard";

export const buildPoliciesUri = () => "/policies";
/** Policy - Edit */
export const buildPolicyUri = (id = ":id") => `${buildPoliciesUri()}/${id}`;
/** Policy - New */
export const buildPolicyNewUri = () => `${buildPoliciesUri()}/new`;

export const buildAdviseesUri = () => "/advisees";
/** Advisee - New - Wizards */
export const buildAdviseeWizardUri = () => `${buildAdviseesUri()}/new`;
export const buildAWPersonalUri = () => `${buildAdviseeWizardUri()}/personal`;
export const buildAWFinancialUri = () => `${buildAdviseeWizardUri()}/financial`;
export const buildAWSummaryUri = () => `${buildAdviseeWizardUri()}/summary`;
/** Advisee - Edit */
export const buildAdviseeUri = (id = ":id") => `${buildAdviseesUri()}/${id}`;
export const buildAdviseePersonalInfoUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/personal`;
export const buildAdviseePoliciesUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/policies`;
export const buildAdviseeCashFlowUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/cashflow`;
export const buildAdviseeEstatePlanningUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/estate`;
export const buildAdviseeInvestmentPortfolioUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/investment`;
export const buildAdviseeNavReprogramUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/reprogram`;
export const buildAdviseeActionPlanUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/action`;
export const buildAdviseeFutureReviewUri = (id = ":id") =>
  `${buildAdviseeUri(id)}/review`;
/** Advisee Personal Info = PPI */
export const buildPPISummaryUri = (id = ":id") =>
  `${buildAdviseePersonalInfoUri(id)}/summary`;
export const buildPPIDetailsUri = (id = ":id") =>
  `${buildAdviseePersonalInfoUri(id)}/details`;
export const buildPPIReportingUri = (id = ":id") =>
  `${buildAdviseePersonalInfoUri(id)}/reporting`;
export const buildPPIUserAttachmentUri = (id = ":id") =>
  `${buildAdviseePersonalInfoUri(id)}/attachment`;
/** Advisee Policies = PPS */
export const buildPPSSummaryUri = (id = ":id") =>
  `${buildAdviseePoliciesUri(id)}/summary`;
export const buildPPSOwnedPoliciesUri = (id = ":id") =>
  `${buildAdviseePoliciesUri(id)}/owned`;
export const buildPPSNewOwnedPoliciesUri = (id = ":id") =>
  `${buildPPSOwnedPoliciesUri(id)}/new`;
export const buildPPSAttachmentUri = (id = ":id") =>
  `${buildAdviseePoliciesUri(id)}/attachment`;
export const buildPPSOwnedPolicyDetailsUri = (
  id = ":id",
  policyId = ":policyId"
) => `${buildPPSOwnedPoliciesUri(id)}/${policyId}`;
/** Advisee Cash Flow = PCF */
export const buildPCFSummaryUri = (id = ":id") =>
  `${buildAdviseeCashFlowUri(id)}/summary`;
export const buildPCFInflowsUri = (id = ":id") =>
  `${buildAdviseeCashFlowUri(id)}/inflows`;
export const buildPCFOutflowsUri = (id = ":id") =>
  `${buildAdviseeCashFlowUri(id)}/outflows`;
/** Advisee Estate Planning = PEP */
export const buildPEPSummaryUri = (id = ":id") =>
  `${buildAdviseeEstatePlanningUri(id)}/summary`;
/** Advisee Investment Portfolio = PIP */
export const buildPIPSummaryUri = (id = ":id") =>
  `${buildAdviseeInvestmentPortfolioUri(id)}/summary`;
export const buildPIPResourcesUri = (id = ":id") =>
  `${buildAdviseeInvestmentPortfolioUri(id)}/resources`;
/** Advisee Nav Reprogram = PNR */
export const buildPNRSummaryUri = (id = ":id") =>
  `${buildAdviseeNavReprogramUri(id)}/summary`;
export const buildPNRProposalsUri = (id = ":id") =>
  `${buildAdviseeNavReprogramUri(id)}/proposals`;
export const buildPNRGptSolutionsUri = (id = ":id") =>
  `${buildAdviseeNavReprogramUri(id)}/gptSolutions`;
export const buildPNRProposalUri = (id = ":id", proposalId = ":proposalId") =>
  `${buildPNRProposalsUri(id)}/${proposalId}`;
/** Advisee Action Plans = PAP */
export const buildPAPSummaryUri = (id = ":id") =>
  `${buildAdviseeActionPlanUri(id)}/summary`;
/** Advisee Future Review = PFR */
export const buildPFRSummaryUri = (id = ":id") =>
  `${buildAdviseeFutureReviewUri(id)}/summary`;

export const buildUsersUri = () => "/users";
/** User - Edit */
export const buildUserUri = (id = ":id") => `${buildUsersUri()}/${id}`;
/** User - New */
export const buildUserNewUri = () => `${buildUsersUri()}/new`;
/** Billing */
export const buildBillingUri = () => "/billing";
export const buildBillingSubscriptionSpecialUri = () =>
  `/billing-subscription/special`;
export const buildBillingSubscriptionUri = () => "/billing-subscription";
export const buildBillingManagementUri = () => "/billing-management";
export const buildBillingSuccessUri = (session_id = ":session_id") =>
  `/billing-subscription/success/${session_id}`;
export const buildBillingCancelUri = () => "/billing-subscription/canceled";

/** Invoice */
export const buildInvoicePDFViewerUri = () => `/invoice/subscription`;
/** Sign Up */
export const buildSignUpUri = () => "/sign-up";
